import type { IconProps } from './Icon.types';

const CloseIcon: React.FC<IconProps> = ({
  className,
  fill = 'currentColor',
  size = 18,
  width = 18,
  height = 18,
}) => (
  <svg
    className={className}
    width={size || width}
    height={size || height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.74656 1.21194C2.54225 1.0146 2.26859 0.90541 1.98455 0.907878C1.7005 0.910346 1.42879 1.02428 1.22793 1.22514C1.02707 1.426 0.913136 1.69771 0.910668 1.98176C0.908199 2.2658 1.01739 2.53946 1.21473 2.74377L7.47098 9.00002L1.21365 15.2563C1.11018 15.3562 1.02765 15.4757 0.970871 15.6079C0.914095 15.7401 0.88421 15.8822 0.88296 16.0261C0.88171 16.1699 0.90912 16.3126 0.963591 16.4457C1.01806 16.5789 1.0985 16.6998 1.20022 16.8015C1.30194 16.9033 1.42289 16.9837 1.55603 17.0382C1.68917 17.0926 1.83182 17.12 1.97567 17.1188C2.11951 17.1175 2.26167 17.0877 2.39384 17.0309C2.52601 16.9741 2.64555 16.8916 2.74548 16.7881L9.00282 10.5319L15.2591 16.7881C15.4634 16.9854 15.737 17.0946 16.0211 17.0922C16.3051 17.0897 16.5768 16.9758 16.7777 16.7749C16.9786 16.5741 17.0925 16.3023 17.095 16.0183C17.0974 15.7342 16.9882 15.4606 16.7909 15.2563L10.5346 9.00002L16.7909 2.74377C16.9882 2.53946 17.0974 2.2658 17.095 1.98176C17.0925 1.69771 16.9786 1.426 16.7777 1.22514C16.5768 1.02428 16.3051 0.910346 16.0211 0.907878C15.737 0.90541 15.4634 1.0146 15.2591 1.21194L9.00282 7.46819L2.74656 1.21086V1.21194Z"
      fill={fill}
    />
  </svg>
);

export default CloseIcon;
